import React, { useEffect, useState } from 'react';
import { FlashcardsStyles as styles } from '../../css/styles';
import { TwoInputsTask } from '../../constants/AllTypes';
import { fetchImage } from '../../utils/functions';
import classNames from 'classnames';
import Taskbar from '../Taskbar';

type FlashcardsProps = {
  task?: TwoInputsTask;
  isFullscreen: boolean;
}

type Flashcard = {
  inputOne: string;
  image?: string | undefined;
  inputTwo?: string | null;
}

const Flashcards: React.FC<FlashcardsProps> = ({ task, isFullscreen }) => {
  const [flashcards, setFlashcards] = useState<Flashcard[]>(task?.taskContent?.items || []);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFlipped, setIsFlipped] = useState(false);
  const totalPages = flashcards?.length ?? 0;
  const currentFlashcard = flashcards?.[currentPage - 1];
  const [fetchedImages, setFetchedImages] = useState<{ [key: string]: string | null }>({});

  useEffect(() => {
    const fetchImageForCurrent = async () => {
      const imageKey = currentFlashcard?.image;
      if (!imageKey || fetchedImages[imageKey]) return;
  
      const imageUrl = await fetchImage(imageKey);
      setFetchedImages(prev => ({
        ...prev,
        [imageKey]: imageUrl,
      }));
    };
  
    fetchImageForCurrent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFlashcard]);

  useEffect(() => {
    if (task?.taskContent && task.taskContent.items) {
      const formattedFlashcards = task.taskContent.items.map(flashcard => ({
        inputOne: flashcard.inputOne,
        image: flashcard.image || '',
        inputTwo: flashcard.inputTwo || '',
      }));

      setFlashcards(formattedFlashcards);
    }
  }, [task]);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  useEffect(()=> {
    setIsFlipped(false)
  }, [currentPage])

  return (
    <div className={styles.flashcards}>
      <div className={classNames(styles.flashcard, {[styles.flashcardFullscreen] : isFullscreen, [styles.flashcardFlipped]: isFlipped})} onClick={handleFlip}>
        <div className={styles.flashcardInner}>
          <div className={classNames(styles.flashcardFront, {[styles.flashcardFrontFullscreen] : isFullscreen})}>          
            {currentFlashcard?.image && (
              <img src={fetchedImages[currentFlashcard.image] || undefined} alt="Flashcard object" />
            )}
            {currentFlashcard?.inputOne && <p className={styles.flashcardText}>{currentFlashcard?.inputOne}</p>}
          </div>
          <div className={classNames(styles.flashcardBack, {[styles.flashcardBackFullscreen]: isFullscreen})}>
            {currentFlashcard?.inputTwo && <p>{currentFlashcard?.inputTwo}</p>}
          </div>
        </div>
      </div>

      
      <Taskbar
        isFullscreen={isFullscreen}
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default Flashcards;


